import React from "react"
import {useState} from "react"
import {graphql, Link, useStaticQuery} from "gatsby";

import love from "../img/love.svg";
import twitter from "../img/icon--twitter.svg";
import discord from "../img/icon--discord.svg";
import telegram from "../img/icon--telegram.svg";
import linkedin from "../img/icon--linkedin.svg";
import youtube from "../img/youtube_footer.svg";
import forum from "../img/forum-white.svg";
import axios from "axios";
import Popup from "./elements/popup";

const twitterLink = 'https://agoric.com/twitter';
const telegramLink = 'https://agoric.com/telegram';
const discordLink = 'https://agoric.com/discord';
const linkedinLink = 'https://agoric.com/linkedin';
const youtubeLink = 'https://youtube.com/agoric';
const forumLink = 'https://community.agoric.com';


const Footer = (s) => {
    const menuQuery = useStaticQuery(graphql`
        query {
            contentfulMenu(contentful_id: { eq: "4xWefFjOAW771YSn9kvWGv" }) {
                ... MenuDetails
            }
        }
    `);
    const {contentfulMenu} = menuQuery;

    const [showPopup, setShowPopup] = useState(false)

    const subscribe = (e) =>{
        e.preventDefault();
        const url = `https://worker-marreg.agoric-core.workers.dev`

        var email = document.getElementById('emailSubscribe').value;

        const data =  {
            "email":email
        }

        try {
            const response = axios({
                method: 'PUT',
                url: url,
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: false
            }).then((res)=>{
                if(res.status === 200){
                    setShowPopup(true)
                }
            });
        } catch (error) {
            console.error(error);
        }
    }

    const renderMenuElement = (element, index) => {
        if (element.isExternal) {
            return (
                <li key={index} className="menu-item">
                    <a href={element.url}>{element.title}</a>
                </li>
            )
        }
        return (
            <li key={index} className="menu-item">
                <Link to={element.url}>{element.title}</Link>
            </li>
        )
    }

    return (
        <footer>
            <Popup showPopup={showPopup} showLaunchPopup={()=>setShowPopup(true)} hideLaunchPopup={()=>setShowPopup(false)}/>

            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="subscribe">
                            <div className="decorate-container">
                                <div className="decorate">
                                    <span className="decorate__item"/>
                                    <span className="decorate__item"/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-7">
                                    <h4>Join the community</h4>
                                    <p>Join our active community of builders and partners</p>
                                </div>
                                <div className="col-lg-4 offset-lg-1 col-md-5">
                                    <div className="social">
                                        <div className="social--icon">
                                            <a href={twitterLink} target="_blank" rel={'noreferrer'}>
                                                <img
                                                    src={twitter}
                                                    alt="Agoric Twitter"/>
                                            </a>
                                        </div>
                                        <div className="social--icon">
                                            <a href={discordLink} target="_blank" rel={'noreferrer'}>
                                                <img
                                                    src={discord}
                                                    alt="Agoric Discord"/>
                                            </a>
                                        </div>
                                        <div className="social--icon">
                                            <a href={telegramLink} target="_blank" rel={'noreferrer'}>
                                                <img
                                                    src={telegram}
                                                    alt="Agoric Telegram"/>
                                            </a>
                                        </div>
                                        <div className="social--icon">
                                            <a href={linkedinLink} target="_blank" rel={'noreferrer'}>
                                                <img
                                                    src={linkedin}
                                                    alt="Agoric Linkedin"/>
                                            </a>
                                        </div>
                                        <div className="social--icon">
                                            <a href={youtubeLink} target="_blank" rel={'noreferrer'}>
                                                <img
                                                    src={youtube}
                                                    alt="Agoric Youtube"/>
                                            </a>
                                        </div>
                                        <div className="social--icon">
                                            <a href={forumLink} target="_blank" rel={'noreferrer'}>
                                                <img
                                                    src={forum}
                                                    alt="Join the community"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="footermenu">
                            <div className="footermenu--item">
                                <div className="newsletter">
                                    <h3>
                                        Subscribe to our<br/>
                                        newsletter for updates
                                    </h3>
                                    <form method="get" id={'subscribe'} target="_blank" onSubmit={subscribe}>
                                        <div className="form-gorup">
                                            <input type="email" name="email" id="emailSubscribe" placeholder="Email address" required={true}/>
                                            <input type="submit" value="Subscribe" className="btn mailchimp-subscribe"/>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {contentfulMenu.elements.map(function (menu, index) {
                                return (
                                    <div key={index} className="footermenu--item">
                                        <h5>{menu.title}</h5>
                                        <div className="menu-company-footer-menu-container">
                                            <ul id="menu-company-footer-menu" className="menu">
                                                {menu.elements.map(function(submenu, i) {
                                                    return(
                                                        renderMenuElement(submenu, i)
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="row foot-text">
                    <div className="col-lg-6 foot-text__inner">
                        <p className={'mb-0'}>© {new Date().getFullYear()} Agoric Systems Operating Company. All Rights Reserved.</p>
                    </div>
                    <div className="col-lg-6 foot-text__inner">
                        <p id="dn" className={'mb-0'}>
                            <a href="https://www.designatives.com/" target="_blank" rel={'noreferrer'}>Made with <img
                            src={love} alt="Designatives"/> by Designatives</a>
                        </p>
                    </div>
                </div>
                <div className={'row foot-text pt-0 pb-5'}>
                    <div className={'col-12 text-center'}>
                        <div className={'row align-items-center justify-content-center justify-content-md-start'}>
                            <div className={'col-auto pe-0'}>
                                <p className={'mb-0'}>
                                    <a href="mailto:info@agoric.com">info@agoric.com</a>
                                </p>
                            </div>
                            {/*<div className={'col-auto p-0'}>*/}
                            {/*    <div className={'divider'}/>*/}
                            {/*</div>*/}
                            {/*<div className={'col-auto p-0 fw-bolder'}>*/}
                            {/*    <a href="tel:+6507472332" className={'link-dark d-block'}>(650) 747-2332</a>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
